export default "__VITE_ASSET__a61495f3__"